exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text[data-v-bc55609a]{\n  font-size:14px;\n}\n.buttonWidth[data-v-bc55609a] {\n  width: 100% !important;\n}\n@media (min-width: 993px) {\n.addGroupMemberGroupList[data-v-bc55609a] {\n    margin-left: 260px !important;\n}\n.search[data-v-bc55609a] {\n    margin-top: 79px !important;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bc55609a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/accounts/CMAddMemberGroupMembersList.vue
// module id = 1164
// module chunks = 2